export const options = {
  startDate: [
    {
      value: "wellsStartDate2",
      label: "February 20, 2020",
    },
    {
      value: "stGeorge4",
      label: "10/10/2020",
    },
    {
      value: "stGeorge3",
      label: "10/10/20",
    },
    {
      value: "uob",
      label: "10 Feb 2020",
    },
    {
      value: "barclaysStart2",
      label: "10 February 2020",
    },
    {
      value: "onPoint2Start",
      label: "10-10-20",
    },
  ],
  endDate: [
    {
      value: "wellsStartDate2",
      label: "February 20, 2020",
    },
    {
      value: "stGeorge4",
      label: "10/10/2020",
    },
    {
      value: "stGeorge3",
      label: "10/10/20",
    },
    {
      value: "uob",
      label: "10 Feb 2020",
    },
    {
      value: "barclaysStart2",
      label: "10 February 2020",
    },
    {
      value: "onPoint2Start",
      label: "10-10-20",
    },
  ],
  startBalance: [
    {
      value: "Previous\\\\s+Balance.*?(${amountNoCapture})",
      label: "Previous Balance $100",
    },
    {
      value: "Beginning\\\\s+Balance.*?(${amountNoCapture})",
      label: "Beginning Balance $100",
    },
  ],
  endBalance: [
    {
      value: "New\\\\s+Balance.*?(${amountNoCapture})",
      label: "New Balance $100",
    },
    {
      value: "Ending\\\\s+Balance.*?(${amountNoCapture})",
      label: "Ending Balance $100",
    },
  ],
};
